<div class="drop-down-multi">
  <span class="name">
    {{name}}
  </span>
  <ng-select
    #selectCause
    dropdownPosition="auto"
    (blur)="onSaveModel()"
    [clearable]="false"
    [(ngModel)]="selectedItems"
    [ngClass]="'custom'"
    [multiple]="true"
    (change)="onChange()"
    (focus)="onOpen()"
    (close)="close()"
    [disabled]="disabled"
    [placeholder]="placeholder"
    [closeOnSelect]="closeOnSelect"
    [attr.data-testid]="testId"
    >
    @for (item of items; track item) {
      <ng-option [value]="item">
        {{ item.name }}
      </ng-option>
    }
    <ng-template ng-multi-label-tmp>
      <div class="multi-selected-label">
        {{ displayMultiLabel() }}
      </div>
    </ng-template>
    <ng-template ng-label-tmp let-item="item" >
    </ng-template>
  </ng-select>
</div>
